'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _state = require('./state');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function render(App, store) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var root = document.getElementById('root');
  _reactDom2.default.render(_react2.default.createElement(
    _state.Provider,
    { store: store },
    _react2.default.createElement(App, props)
  ), root);
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/render.js
// module id = 142
// module chunks = 0